import { LOGO_ICON } from "../../lib/content";

const cols = [
  { title: "Product", links: ["Accept", "Pay Out", "Hold", "Nomoex Card", "P2P Transfers", "Embed"] },
  { title: "Company", links: ["About", "Careers", "Press", "Contact"] },
  { title: "Resources", links: ["Docs", "API Reference", "Status", "Pricing"] },
  { title: "Legal", links: ["Terms", "Privacy", "AML Policy", "Licenses"] },
];

export const Footer = () => (
  <footer className="noise-overlay bg-[#0A0C14] pt-20" data-testid="footer">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <div className="grid grid-cols-2 gap-x-6 gap-y-12 pb-16 lg:grid-cols-6">
        <div className="col-span-2">
          <div className="flex items-center gap-3">
            <img src={LOGO_ICON} alt="Nomoex" className="h-9 w-9 rounded-lg bg-white p-1" />
            <span className="font-heading text-lg font-medium text-white">Nomoex Pay</span>
          </div>
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-slate-500">
            The payment platform for the future of money. Accept, pay out, hold, spend, embed.
          </p>
        </div>
        {cols.map((c) => (
          <div key={c.title}>
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-500">{c.title}</p>
            <ul className="mt-5 space-y-3">
              {c.links.map((l) => (
                <li key={l}>
                  <a href="#top" className="text-sm text-slate-400 transition-colors duration-200 hover:text-white">{l}</a>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="border-t border-white/10 py-8">
        <p className="text-xs text-slate-600">
          © 2026 Nomoex Pay. All rights reserved. Digital asset services are subject to jurisdiction-specific licensing. Not available in restricted territories.
        </p>
      </div>
    </div>
  </footer>
);
